import { useIntl } from 'react-intl';
import { useNavigate, useOutletContext } from 'react-router-dom';
import AccionaBigButton from '../../../../components/AccionaBigButton';

const Home = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { project } = useOutletContext();
  const normative = project?.id_normative === 1 ? 'ehe' : 'ce';

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-4 col-md-4">
        <AccionaBigButton
          id="traceability"
          icon="normative-traceability"
          onClick={() => {
            navigate('traceability');
          }}
          msg={intl.formatMessage({ id: `button.traceability` })}
        />
      </div>
      <div className="col-xs-12 col-sm-4 col-md-4">
        <AccionaBigButton
          id="statisticalControl"
          icon="normative-statisticalControl"
          onClick={() => {
            //navigate('statisticalControl');
            navigate(`../${normative}/concreteTypesEst`);
          }}
          msg={intl.formatMessage({ id: `button.statisticalControl` })}
        />
      </div>
      <div className="col-xs-12 col-sm-4 col-md-4">
        <AccionaBigButton
          id="100%Control"
          icon="normative-100Control"
          onClick={() => {
            // navigate('100%Control');
            navigate(`../${normative}/concreteTypes100`);
          }}
          msg={intl.formatMessage({ id: `button.100%Control` })}
        />
      </div>
    </div>
  );
};

export default Home;
